import { render, staticRenderFns } from "./plan-edit.vue?vue&type=template&id=5f470282&scoped=true"
import script from "./plan-edit.vue?vue&type=script&lang=js"
export * from "./plan-edit.vue?vue&type=script&lang=js"
import style0 from "./plan-edit.vue?vue&type=style&index=0&id=5f470282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f470282",
  null
  
)

export default component.exports